import { render } from "./EventDetails.vue?vue&type=template&id=027447a2"
import script from "./EventDetails.vue?vue&type=script&lang=ts"
export * from "./EventDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script